<template>
  <div>
    <el-dialog
      ref="addEditViewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h660_dialog abow_dialog"
      width="1280px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @open="handleOpen('addEditViewDialog')"
    >
      <div
        v-loading="loading"
        :loading="loading"
        :element-loading-text="$t('detailPage.loading')"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form
          ref="dialogAddEditViewForm"
          :model="dialogAddEditViewForm"
          :rules="eventType==='view' ? null : dialogAddEditViewFormRules"
          class="add-edit-view-form"
          @submit.native.prevent
        >
          <div class="modal-box">
            <h3 class="modal-title">
              基础信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item
                    label="姓名"
                    prop="name"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.name"
                      disabled
                    >
                      <el-button
                        v-if="eventType==='add'"
                        slot="append"
                        icon="el-icon-search"
                        @click="showUserFun()"
                      />
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="省区">
                    <el-input
                      v-model="dialogAddEditViewForm.provinceName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="详细地址"
                    prop="address"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.address"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="微信OPENID">
                    <el-input
                      v-model="dialogAddEditViewForm.wxOpenId"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="电话">
                    <el-input
                      v-model="dialogAddEditViewForm.phone"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="性别">
                    <el-input
                      v-model="dialogAddEditViewForm.sexStr"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item
                    label="消息标题"
                    prop="messageTitle"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.messageTitle"
                      :disabled="eventType==='view'"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item
                    label="消息内容"
                    prop="messageData"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.messageData"
                      type="textarea"
                      autosize
                      :disabled="eventType==='view'"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="modal-box">
            <h3 class="modal-title">
              备注信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item prop="remark">
                    <el-input
                      v-model="dialogAddEditViewForm.remark"
                      type="textarea"
                      placeholder="备注"
                      style="margin-top:10px;"
                      :disabled="eventType==='view'"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          v-if="eventType!=='view'"
          type="primary"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
    <!-- 用户列表 -->
    <user-list-dialog
      :type="1"
      :dialog-visible.sync="dialogUserVisible"
      dialog-title="用户信息"
      @selectedUserFun="selectedUserFun"
    />
  </div>
</template>
<script>
// 数据请求
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 用户
import userListDialog from './userListDialog'
import { initAppConsumerMessageApi, saveOrUpdateAppConsumerMessageApi } from '@/api/appConsumerMessage'
export default {
  components: { userListDialog },
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loading: true,
      dialogAddEditViewForm: {
      },
      dialogAddEditViewFormRules: {
        name: [{ required: true, message: '请选择用户', trigger: 'blur' }],
        messageTitle: [{ required: true, message: '请输入消息标题', trigger: 'blur' }, { max: 128, message: '最多输入128个字符', trigger: 'blur' }],
        messageData: [{ required: true, message: '请输入消息内容', trigger: 'blur' }, { max: 1024, message: '最多输入1024个字符', trigger: 'blur' }],
        remark: [{ max: 128, message: '最多输入128个字符', trigger: 'blur' }]
      },
      dialogUserVisible: false
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.dialogAddEditViewForm.clearValidate()
        })
        this.loading = true
        this.dialogAddEditViewForm = {
          provinceName: '',
          cityName: '',
          countyName: '',
          name: '',
          wxOpenId: '',
          phone: '',
          sexStr: '',
          address: '',
          messageTitle: '',
          messageData: '',
          status: 1,
          remark: ''
        }
        if (this.eventType !== 'add') {
          this.initConsumerData()
        } else {
          this.loading = false
        }
      }
    }
  },
  methods: {
    // 加载数据
    initConsumerData() {
      initAppConsumerMessageApi({ id: this.dataId }).then(res => {
        const { data } = res
        for (let key in this.dialogAddEditViewForm) {
          this.dialogAddEditViewForm[key] = data[key]
        }
        this.dialogAddEditViewForm.id = data.id
        this.loading = false
      })
    },
    //选择用户
    showUserFun() {
      this.dialogUserVisible = !this.dialogUserVisible
    },
    selectedUserFun(userObj) {
      this.dialogAddEditViewForm.provinceName = userObj.provinceName
      this.dialogAddEditViewForm.sexStr = userObj.sexStr
      this.dialogAddEditViewForm.wxOpenId = userObj.wxOpenId
      this.dialogAddEditViewForm.name = userObj.name
      this.dialogAddEditViewForm.phone = userObj.phone
      this.dialogAddEditViewForm.address = userObj.address
      this.dialogAddEditViewForm.consumerId = userObj.id
    },
    // 加载数据
    reloadData() {
      this.$emit('reloadData')
    },
    modalClose() {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
      this.$refs.dialogAddEditViewForm.clearValidate()
    },
    // 新增|修改保存
    handleSave() {
      this.$refs.dialogAddEditViewForm.validate(valid => {
        if (valid) {
          this.$confirm(
            (this.eventType === 'add' ? '是否确定新增' : '是否确定修改') + '用户消息', '系统提示',
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
              center: true
            }
          )
            .then(async () => {
              this.loading = true
              this.handlerSave()
            })
            .catch(() => { })
        }
      })
    },
    // 保存
    handlerSave() {
      saveOrUpdateAppConsumerMessageApi(this.dialogAddEditViewForm).then(res => {
        if (res.mark === '200') {
          this.$message({ message: res.message, type: 'success' })
          this.reloadData()
          this.modalClose()
        }
      }).catch(() => {
        this.loading = false
      })
    },
  }
}
</script>
<style lang="scss"  scoped>
.el-table--border {
  border-left: 1px solid #dfe6ec;
  margin-top: 5px;
}
::v-deep .el-table {
  th {
    color: #ffffff;
    .cell {
      line-height: 17px;
    }
    .caret-wrapper {
      height: 18px;
    }
    .sort-caret {
      border-width: 4px;
      &.ascending {
        top: 0;
      }
      &.descending {
        bottom: 0;
      }
    }
  }
  .ascending .sort-caret.ascending {
    border-bottom-color: #ffffff;
  }
  .descending .sort-caret.descending {
    border-top-color: #ffffff !important;
  }
}
::v-deep .el-table--mini th,
::v-deep .el-table--mini td {
  padding: 4px;
  font-size: 12px;
}
::v-deep .el-table--mini td {
  padding: 4px;
}
::v-deep .el-table__row {
  .el-form-item__error {
    display: none;
  }
  .el-form-item--mini.el-form-item {
    margin-bottom: 0px;
  }
}
</style>
